<template>
  <bb-modal
    visible
    flavor="card"
    color="white"
    publicSize="s"
    fullMobile
    centerVertically
    @close="$emit('close', $event)">
    <div
      v-if="iframeLoading"
      class="iframe-loader"
    >
      <bb-spinner/>
    </div>
    <iframe
      class="p-b-10"
      v-show="!iframeLoading"
      :src="redirectUrl"
      height="460px"
      width="100%"
      @load="iframeLoaded"
      @error="iframeLoaded"
    />
  </bb-modal>
</template>

<script>
import {
  SigningRequestStatus
} from '@bigbank/dc-common/clients/http/signing-service-backend/signing-service-backend.enums'

export default {
  name: 'sign-iframe-modal',
  props: {
    signingRequestId: {
      required: true,
      type: String
    },
    redirectUrl: {
      required: true,
      type: String
    },
    completeSigning: {
      required: true,
      type: Function
    }
  },
  data () {
    return {
      iframeLoading: true
    }
  },
  methods: {
    async verifyRequestStatus () {
      try {
        const {
          signingRequestStatus,
          failedPaymentIds,
          successfulPaymentIds
        } = await this.completeSigning(this.signingRequestId)

        if (signingRequestStatus === SigningRequestStatus.Completed) {
          this.$emit('signingSuccessful', { failedPaymentIds, successfulPaymentIds })
        } else if (signingRequestStatus === SigningRequestStatus.Failed) {
          this.$emit('signingError')
        } else if (signingRequestStatus === SigningRequestStatus.Cancelled) {
          this.$emit('signingCancelled')
        } else {
          throw new Error('Unexpected signing request status: ' + signingRequestStatus)
        }
      } catch (error) {
        this.$emit('signingError')
      }
    },
    iframeLoaded () {
      this.iframeLoading = false
    }
  },
  mounted () {
    window.addEventListener('message', async ({ data }) => {
      if (data?.signingSessionStatus) {
        await this.verifyRequestStatus()
      }
      if (data?.redirectUrl) {
        document.location = data.redirectUrl
      }
    })
  }
}
</script>

<style lang="scss">
.iframe-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 460px;
  width: 100%;
}
</style>
